// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_mainBlock__vyR\\+w {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: var(--PADDING_24) 0px;
  border-bottom: var(--SIZE_BORDER) solid var(--COLOR_PRIMARY_350);
}

.styles_inputsBlock__XdXxH {
  width: 100%;
  height: max-content;
  display: flex;
  flex-direction: row;
  margin-bottom: var(--MARGIN_16);
}

.styles_firstInputFromBlock__9zMVK {
  display: flex;
  flex-direction: column;
}

.styles_secondInputFromBlock__q76n1 {
  display: flex;
  flex-direction: column;
  margin-left: var(--MARGIN_9);
}

.styles_nameInputStyle__NoCfC {
  height: var(--SIZE_44);
  padding-left: var(--PADDING_14);
  padding-right: var(--PADDING_14);
  padding-top: var(--PADDING_2);
  font-family: var(--FONT_DEFAULT);
  font-style: normal;
  font-weight: var(--WEIGHT_400);
  font-size: var(--FONT_SIZE_SUB_TITLE);
  line-height: var(--LINE_HEIGHT_24);
  color: var(--COLOR_GRAY_900);
  box-shadow: 0 var(--SIZE_1) var(--SIZE_2) var(--COLOR_GRAY_900_LIGHT);
}

.styles_nameInputStyle__NoCfC::placeholder {
  font-family: var(--FONT_DEFAULT);
  font-style: normal;
  font-weight: var(--WEIGHT_400);
  font-size: var(--FONT_SIZE_SUB_TITLE);
  line-height: var(--LINE_HEIGHT_24);
  color: var(--COLOR_PRIMARY_950);
}

.styles_menuTitleText__hiHmt {
  padding-bottom: var(--PADDING_6);
  font-family: var(--FONT_MEDIUM);
  font-style: normal;
  font-weight: var(--WEIGHT_NORMAL);
  font-size: var(--FONT_SIZE_TEXT);
  line-height: var(--LINE_HEIGHT_20);
  color: var(--COLOR_PRIMARY_950);
}

.styles_emailInputBlock__ZDwFp {
  margin-bottom: var(--MARGIN_16);
}

.styles_selectMenuBlock__UlB6G {
  margin-bottom: var(--MARGIN_16);
}

.styles_upSocialInputBlock__uz6jc {
  width: 100%;
  display: flex;
  margin-top: var(--MARGIN_2);
  margin-bottom: var(--MARGIN_8);
}

.styles_centerSocialInputBlock__iWue\\+ {
  width: 100%;
  display: flex;
  margin-bottom: var(--MARGIN_8);
}

.styles_downSocialInputBlock__6cLEH {
  width: 100%;
  display: flex;
  margin-bottom: var(--MARGIN_24);
}

.styles_contentTitleFromSocialBlock__\\+pGPA {
  width: max-content;
  height: max-content;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--PADDING_9) var(--PADDING_12) var(--PADDING_9) var(--PADDING_14);
  border-top: var(--SIZE_BORDER) solid var(--COLOR_PRIMARY_850);
  border-bottom: var(--SIZE_BORDER) solid var(--COLOR_PRIMARY_850);
  border-left: var(--SIZE_BORDER) solid var(--COLOR_PRIMARY_850);
  border-top-left-radius: var(--RADIUS_8);
  border-bottom-left-radius: var(--RADIUS_8);
}

.styles_contentTitleFromSocialStyle__GjAsR {
  font-family: var(--FONT_DEFAULT);
  font-style: normal;
  font-weight: var(--WEIGHT_400);
  font-size: var(--FONT_SIZE_SUB_TITLE);
  line-height: var(--LINE_HEIGHT_24);
  color: var(--COLOR_GRAY_600);
}

.styles_socialInputStyle__yO8tb {
  padding: var(--PADDING_10) var(--PADDING_14);
  height: var(--SIZE_44);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  font-family: var(--FONT_DEFAULT);
  font-style: normal;
  font-weight: var(--WEIGHT_400);
  font-size: var(--FONT_SIZE_SUB_TITLE);
  line-height: var(--LINE_HEIGHT_24);
  color: var(--COLOR_GRAY_900);
}

.styles_addLablesInputStyle__9pjZC {
  margin-bottom: var(--MARGIN_12);
  padding: var(--PADDING_10) var(--PADDING_14);
  height: var(--SIZE_44);
  font-family: var(--FONT_DEFAULT);
  font-style: normal;
  font-weight: var(--WEIGHT_400);
  font-size: var(--FONT_SIZE_SUB_TITLE);
  line-height: var(--LINE_HEIGHT_24);
  color: var(--COLOR_GRAY_900);
  box-shadow: 0 var(--SIZE_1) var(--SIZE_2) var(--COLOR_GRAY_900_LIGHT);
}

.styles_addLablesInputStyle__9pjZC::placeholder {
  font-family: var(--FONT_DEFAULT);
  font-style: normal;
  font-weight: var(--WEIGHT_400);
  font-size: var(--FONT_SIZE_SUB_TITLE);
  line-height: var(--LINE_HEIGHT_24);
  color: var(--COLOR_GRAY_500);
}

.styles_addLablesBlock__OTKtf {
  margin-bottom: var(--MARGIN_24);
}

.styles_agencyInputStyle__Q43L7 {
  height: var(--SIZE_44);
  margin-bottom: var(--MARGIN_24);
  padding: var(--PADDING_10) var(--PADDING_14);
  font-family: var(--FONT_DEFAULT);
  font-style: normal;
  font-weight: var(--WEIGHT_400);
  font-size: var(--FONT_SIZE_SUB_TITLE);
  line-height: var(--LINE_HEIGHT_24);
  color: var(--COLOR_GRAY_900);
  box-shadow: 0 var(--SIZE_1) var(--SIZE_2) var(--COLOR_GRAY_900_LIGHT);
}

.styles_textAreaStyle__stkzP {
  margin-top: var(--MARGIN_2);
  padding: var(--PADDING_10) var(--PADDING_14);
  font-family: var(--FONT_DEFAULT);
  font-style: normal;
  font-weight: var(--WEIGHT_400);
  font-size: var(--FONT_SIZE_SUB_TITLE);
  line-height: var(--LINE_HEIGHT_24);
  color: var(--COLOR_GRAY_900);
  box-shadow: 0 var(--SIZE_1) var(--SIZE_2) var(--COLOR_GRAY_900_LIGHT);
}

.styles_textAreaStyle__stkzP::placeholder {
  font-family: var(--FONT_DEFAULT);
  font-style: normal;
  font-weight: var(--WEIGHT_400);
  font-size: var(--FONT_SIZE_SUB_TITLE);
  line-height: var(--LINE_HEIGHT_24);
  color: var(--COLOR_PRIMARY_950);
}

.styles_footerBlock__r6BuO {
  width: 100%;
  display: flex;
  flex-direction: row;
  /* padding: var(--PADDING_24); */
}

.styles_buttonCancelStyle__fptF3 {
  width: 100%;
  padding-right: var(--PADDING_12);
}

.styles_buttonCreateStyle__hWU\\+2 {
  width: 100%;
}

.styles_selectPopupStyle__jNCqo {
  z-index: 2501;
}

.styles_selectStyle__qAYnJ .ant-select-selector {
  padding: 4px 10px !important;
  height: auto !important;
}

.styles_selectStyle__qAYnJ .ant-select-selection-placeholder {
  font-family: var(--FONT_DEFAULT);
  font-style: normal;
  font-weight: var(--WEIGHT_400);
  font-size: var(--FONT_SIZE_SUB_TITLE);
  line-height: var(--LINE_HEIGHT_24);
  color: var(--COLOR_GRAY_500_LIGHT);
}

.styles_verifiedBlock__kMcGB {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: var(--MARGIN_16);
}
`, "",{"version":3,"sources":["webpack://./src/components/organisms/forms/CreatorForm/styles.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gEAAgE;AAClE;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,gCAAgC;EAChC,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,kCAAkC;EAClC,4BAA4B;EAC5B,qEAAqE;AACvE;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8EAA8E;EAC9E,6DAA6D;EAC7D,gEAAgE;EAChE,8DAA8D;EAC9D,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,4CAA4C;EAC5C,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,gCAAgC;EAChC,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,4CAA4C;EAC5C,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,kCAAkC;EAClC,4BAA4B;EAC5B,qEAAqE;AACvE;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,4CAA4C;EAC5C,gCAAgC;EAChC,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,kCAAkC;EAClC,4BAA4B;EAC5B,qEAAqE;AACvE;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,gCAAgC;EAChC,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,kCAAkC;EAClC,4BAA4B;EAC5B,qEAAqE;AACvE;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B","sourcesContent":[".mainBlock {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: var(--PADDING_24) 0px;\n  border-bottom: var(--SIZE_BORDER) solid var(--COLOR_PRIMARY_350);\n}\n\n.inputsBlock {\n  width: 100%;\n  height: max-content;\n  display: flex;\n  flex-direction: row;\n  margin-bottom: var(--MARGIN_16);\n}\n\n.firstInputFromBlock {\n  display: flex;\n  flex-direction: column;\n}\n\n.secondInputFromBlock {\n  display: flex;\n  flex-direction: column;\n  margin-left: var(--MARGIN_9);\n}\n\n.nameInputStyle {\n  height: var(--SIZE_44);\n  padding-left: var(--PADDING_14);\n  padding-right: var(--PADDING_14);\n  padding-top: var(--PADDING_2);\n  font-family: var(--FONT_DEFAULT);\n  font-style: normal;\n  font-weight: var(--WEIGHT_400);\n  font-size: var(--FONT_SIZE_SUB_TITLE);\n  line-height: var(--LINE_HEIGHT_24);\n  color: var(--COLOR_GRAY_900);\n  box-shadow: 0 var(--SIZE_1) var(--SIZE_2) var(--COLOR_GRAY_900_LIGHT);\n}\n\n.nameInputStyle::placeholder {\n  font-family: var(--FONT_DEFAULT);\n  font-style: normal;\n  font-weight: var(--WEIGHT_400);\n  font-size: var(--FONT_SIZE_SUB_TITLE);\n  line-height: var(--LINE_HEIGHT_24);\n  color: var(--COLOR_PRIMARY_950);\n}\n\n.menuTitleText {\n  padding-bottom: var(--PADDING_6);\n  font-family: var(--FONT_MEDIUM);\n  font-style: normal;\n  font-weight: var(--WEIGHT_NORMAL);\n  font-size: var(--FONT_SIZE_TEXT);\n  line-height: var(--LINE_HEIGHT_20);\n  color: var(--COLOR_PRIMARY_950);\n}\n\n.emailInputBlock {\n  margin-bottom: var(--MARGIN_16);\n}\n\n.selectMenuBlock {\n  margin-bottom: var(--MARGIN_16);\n}\n\n.upSocialInputBlock {\n  width: 100%;\n  display: flex;\n  margin-top: var(--MARGIN_2);\n  margin-bottom: var(--MARGIN_8);\n}\n\n.centerSocialInputBlock {\n  width: 100%;\n  display: flex;\n  margin-bottom: var(--MARGIN_8);\n}\n\n.downSocialInputBlock {\n  width: 100%;\n  display: flex;\n  margin-bottom: var(--MARGIN_24);\n}\n\n.contentTitleFromSocialBlock {\n  width: max-content;\n  height: max-content;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: var(--PADDING_9) var(--PADDING_12) var(--PADDING_9) var(--PADDING_14);\n  border-top: var(--SIZE_BORDER) solid var(--COLOR_PRIMARY_850);\n  border-bottom: var(--SIZE_BORDER) solid var(--COLOR_PRIMARY_850);\n  border-left: var(--SIZE_BORDER) solid var(--COLOR_PRIMARY_850);\n  border-top-left-radius: var(--RADIUS_8);\n  border-bottom-left-radius: var(--RADIUS_8);\n}\n\n.contentTitleFromSocialStyle {\n  font-family: var(--FONT_DEFAULT);\n  font-style: normal;\n  font-weight: var(--WEIGHT_400);\n  font-size: var(--FONT_SIZE_SUB_TITLE);\n  line-height: var(--LINE_HEIGHT_24);\n  color: var(--COLOR_GRAY_600);\n}\n\n.socialInputStyle {\n  padding: var(--PADDING_10) var(--PADDING_14);\n  height: var(--SIZE_44);\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  font-family: var(--FONT_DEFAULT);\n  font-style: normal;\n  font-weight: var(--WEIGHT_400);\n  font-size: var(--FONT_SIZE_SUB_TITLE);\n  line-height: var(--LINE_HEIGHT_24);\n  color: var(--COLOR_GRAY_900);\n}\n\n.addLablesInputStyle {\n  margin-bottom: var(--MARGIN_12);\n  padding: var(--PADDING_10) var(--PADDING_14);\n  height: var(--SIZE_44);\n  font-family: var(--FONT_DEFAULT);\n  font-style: normal;\n  font-weight: var(--WEIGHT_400);\n  font-size: var(--FONT_SIZE_SUB_TITLE);\n  line-height: var(--LINE_HEIGHT_24);\n  color: var(--COLOR_GRAY_900);\n  box-shadow: 0 var(--SIZE_1) var(--SIZE_2) var(--COLOR_GRAY_900_LIGHT);\n}\n\n.addLablesInputStyle::placeholder {\n  font-family: var(--FONT_DEFAULT);\n  font-style: normal;\n  font-weight: var(--WEIGHT_400);\n  font-size: var(--FONT_SIZE_SUB_TITLE);\n  line-height: var(--LINE_HEIGHT_24);\n  color: var(--COLOR_GRAY_500);\n}\n\n.addLablesBlock {\n  margin-bottom: var(--MARGIN_24);\n}\n\n.agencyInputStyle {\n  height: var(--SIZE_44);\n  margin-bottom: var(--MARGIN_24);\n  padding: var(--PADDING_10) var(--PADDING_14);\n  font-family: var(--FONT_DEFAULT);\n  font-style: normal;\n  font-weight: var(--WEIGHT_400);\n  font-size: var(--FONT_SIZE_SUB_TITLE);\n  line-height: var(--LINE_HEIGHT_24);\n  color: var(--COLOR_GRAY_900);\n  box-shadow: 0 var(--SIZE_1) var(--SIZE_2) var(--COLOR_GRAY_900_LIGHT);\n}\n\n.textAreaStyle {\n  margin-top: var(--MARGIN_2);\n  padding: var(--PADDING_10) var(--PADDING_14);\n  font-family: var(--FONT_DEFAULT);\n  font-style: normal;\n  font-weight: var(--WEIGHT_400);\n  font-size: var(--FONT_SIZE_SUB_TITLE);\n  line-height: var(--LINE_HEIGHT_24);\n  color: var(--COLOR_GRAY_900);\n  box-shadow: 0 var(--SIZE_1) var(--SIZE_2) var(--COLOR_GRAY_900_LIGHT);\n}\n\n.textAreaStyle::placeholder {\n  font-family: var(--FONT_DEFAULT);\n  font-style: normal;\n  font-weight: var(--WEIGHT_400);\n  font-size: var(--FONT_SIZE_SUB_TITLE);\n  line-height: var(--LINE_HEIGHT_24);\n  color: var(--COLOR_PRIMARY_950);\n}\n\n.footerBlock {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  /* padding: var(--PADDING_24); */\n}\n\n.buttonCancelStyle {\n  width: 100%;\n  padding-right: var(--PADDING_12);\n}\n\n.buttonCreateStyle {\n  width: 100%;\n}\n\n.selectPopupStyle {\n  z-index: 2501;\n}\n\n.selectStyle :global(.ant-select-selector) {\n  padding: 4px 10px !important;\n  height: auto !important;\n}\n\n.selectStyle :global(.ant-select-selection-placeholder) {\n  font-family: var(--FONT_DEFAULT);\n  font-style: normal;\n  font-weight: var(--WEIGHT_400);\n  font-size: var(--FONT_SIZE_SUB_TITLE);\n  line-height: var(--LINE_HEIGHT_24);\n  color: var(--COLOR_GRAY_500_LIGHT);\n}\n\n.verifiedBlock {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: var(--MARGIN_16);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainBlock": `styles_mainBlock__vyR+w`,
	"inputsBlock": `styles_inputsBlock__XdXxH`,
	"firstInputFromBlock": `styles_firstInputFromBlock__9zMVK`,
	"secondInputFromBlock": `styles_secondInputFromBlock__q76n1`,
	"nameInputStyle": `styles_nameInputStyle__NoCfC`,
	"menuTitleText": `styles_menuTitleText__hiHmt`,
	"emailInputBlock": `styles_emailInputBlock__ZDwFp`,
	"selectMenuBlock": `styles_selectMenuBlock__UlB6G`,
	"upSocialInputBlock": `styles_upSocialInputBlock__uz6jc`,
	"centerSocialInputBlock": `styles_centerSocialInputBlock__iWue+`,
	"downSocialInputBlock": `styles_downSocialInputBlock__6cLEH`,
	"contentTitleFromSocialBlock": `styles_contentTitleFromSocialBlock__+pGPA`,
	"contentTitleFromSocialStyle": `styles_contentTitleFromSocialStyle__GjAsR`,
	"socialInputStyle": `styles_socialInputStyle__yO8tb`,
	"addLablesInputStyle": `styles_addLablesInputStyle__9pjZC`,
	"addLablesBlock": `styles_addLablesBlock__OTKtf`,
	"agencyInputStyle": `styles_agencyInputStyle__Q43L7`,
	"textAreaStyle": `styles_textAreaStyle__stkzP`,
	"footerBlock": `styles_footerBlock__r6BuO`,
	"buttonCancelStyle": `styles_buttonCancelStyle__fptF3`,
	"buttonCreateStyle": `styles_buttonCreateStyle__hWU+2`,
	"selectPopupStyle": `styles_selectPopupStyle__jNCqo`,
	"selectStyle": `styles_selectStyle__qAYnJ`,
	"verifiedBlock": `styles_verifiedBlock__kMcGB`
};
export default ___CSS_LOADER_EXPORT___;
